/*jslint nomen: true, regexp: true, unparam: true, sloppy: true, white: true, node: true */
/*global window, console, document, $, jQuery, google */


/**
 * On document ready
 */
jQuery(document).ready(function ($) {

	/** Fastclick */
	FastClick.attach(document.body);

	/** Header */
	$('.header').each(function () {
		var _self = $(this), _nav = $('.nav', _self), body = $('body');

		/** Toggle navigation */
		_nav.each(function () {
			$('ul', _nav).wrap("<div class='space'></div>");
		});
		_self.find('.wrapper').append('<span class="toggle"></span>');
		$('.toggle', _self).on('click', function () {
			body.addClass('nav-visible').on('click', function () {
				if ($(this).hasClass('nav-done')) {
					$(this).removeClass('nav-done');
					setTimeout(function () {
						body.removeClass('nav-visible');
					}, 500);
				}
			});
			if (!$('body').is('.nav-done')) {
				setTimeout(function () {
					body.addClass('nav-done');
				}, 20);
			} else {
				body.removeClass('nav-done');
				setTimeout(function () {
					body.removeClass('nav-visible');
				}, 500);
			}
		});
	});

	/** Gallery */
	$('.gallery').each(function () {
		var fo = $('.for', this), nav = $('.nav', this);
		fo.slick({
            // lazyLoad: 'ondemand',
			autoplay: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: nav,
			mobileFirst: true,
			adaptiveHeight: true,
			arrows: false,
			prevArrow: '<span class="slick-arrow slick-prev"></span>',
			nextArrow: '<span class="slick-arrow slick-next"></span>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: true,
						fade: true
					}
				}
			]
		});
		nav.slick({
			autoplay: true,
			slidesToShow: 3,
			asNavFor: fo,
			focusOnSelect: true,
			mobileFirst: true,
			centerMode: true,
			arrows: false,
			responsive: [
				{
					breakpoint: 550,
					settings: {
						slidesToShow: 5
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 7
					}
				}
			]
		});
	});

	/** Tabs */
	$('.tabs').each(function () {
		$('a', this).click(function () {
			var where = $(this).attr("href").replace(/^.*#(.*)/, "$1");
			$(this).closest('li').addClass('active').siblings('li.active').removeClass('active');
			$('#' + where).removeClass('tab-hidden').siblings('.tab').addClass('tab-hidden');
			$('.slick-initialized').slick('setPosition');
			return false;
		});
	});

	/** Testimonials */
	$('.testimonials').each(function () {
		$('.carousel', this).slick({
			autoplay: true,
			autoplaySpeed: 8000,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			prevArrow: '<span class="slick-arrow slick-prev"></span>',
			nextArrow: '<span class="slick-arrow slick-next"></span>'
		});
	});

	/** Partners */
	$('.partners').each(function () {
		$('.carousel', this).slick({
			variableWidth: true,
			slidesToScroll: 1,
			slidesToShow: 3,
			centerMode: true,
			infinite: true,
			placeholders: true,
			prevArrow: '<span class="slick-arrow slick-prev"></span>',
			nextArrow: '<span class="slick-arrow slick-next"></span>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						variableWidth: false
					}
				},
				{
					breakpoint: 568,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						variableWidth: false
					}
				}
			]
		});
	});

	/** Team */
	$('.team').each(function () {
		$('.carousel', this).slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			centerMode: true,
			centerPadding: 0,
			prevArrow: '<span class="slick-arrow slick-prev"></span>',
			nextArrow: '<span class="slick-arrow slick-next"></span>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 568,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: false
					}
				}
			]
		});
	});

	/** Gallery */
	$('.gallery-small').slick({
		autoplay: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		adaptiveHeight: true,
		prevArrow: '<span class="slick-arrow slick-prev"></span>',
		nextArrow: '<span class="slick-arrow slick-next"></span>',
		responsive: [
			{
				breakpoint: 568,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}
		]
	});

	/** Google Map */
	$('.map', this).each(function () {
		window.mapCont = $('.space', this);
		window.body = $('body');
		/* Map initialization */
		window.mapInit = function () {
			if (typeof google != 'undefined') {
				var pos = [], style, theme;

				window.departmentMarkers = [];
				window.departmentPopups = [];
				window.openedPopup = null;

				var center;
				var zoom = 16;
				var draggable = true;

				if (typeof(data.departments) !== 'undefined') {
					var firstKey = Object.keys(data.departments)[0];
					center = new google.maps.LatLng(data.departments[firstKey].lat, data.departments[firstKey].lng)
				} else {
					center = new google.maps.LatLng(55.60020644597107, 37.79326419492189);
				}

				if (data.currentDepartment) {
					var d = data.departments[data.currentDepartment];
					center = new google.maps.LatLng(d.lat, d.lng);
					zoom = 16;
				}

				var pin = {
					url: '/content/themes/footlandiya/img/icons/pin.png',
					size: new google.maps.Size(33, 47),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(16, 46),
					scaledSize: new google.maps.Size(33, 47)
				};
				var activePin = {
					url: '/content/themes/footlandiya/img/icons/pin-active.png',
					size: google.maps.Size(51, 66),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(20, 51),
					scaledSize: new google.maps.Size(51, 66)
				};

				window.map = new google.maps.Map(mapCont[0], {
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					center: center,
					zoom: zoom,
					draggable: true,
					gestureHandling: 'cooperative',
					scrollwheel: false,
					disableDefaultUI: true,
					zoomControl: true,
					backgroundColor: "#4e4e4e"
				});

				if (data.departments) {
					$.each(data.departments, function (i, v) {
						var position = new google.maps.LatLng(v.lat, v.lng);
						departmentMarkers[i] = new google.maps.Marker({position: position, map: map, icon: pin});
						departmentPopups[i] = new google.maps.InfoWindow({
							content: '<div class="map-popup">' + $('.map-popup-' + i).html() + '</div>',
							pixelOffset: new google.maps.Size(0, 0)
						});
					});

					$.each(data.departments, function (i) {
						google.maps.event.addListener(departmentPopups[i], 'domready', function () {
							$('.gm-style-iw').siblings('*').hide();
						});
						google.maps.event.addListener(departmentMarkers[i], 'click', function () {
							if (openedPopup) {
								departmentMarkers[openedPopup].setIcon(pin);
								departmentPopups[openedPopup].close();
							}
							departmentMarkers[i].setIcon(activePin);
							departmentPopups[i].open(map, departmentMarkers[i]);
							openedPopup = i;
							initPopups($('.map-popup:visible'));
						});
						google.maps.event.addListener(map, 'click', function () {
							departmentMarkers[i].setIcon(pin);
							departmentPopups[i].close();
							openedPopup = null;
						});
					});

					// Установка масштаба и центра так, чтобы чтобы все отметки влезали
					if (Object.keys(departmentMarkers).length > 1) {
						var bounds = new google.maps.LatLngBounds();
						departmentMarkers.forEach(function(current, index, array) {
							bounds.extend(current.getPosition());
						})

						window.map.fitBounds(bounds);
					}
				}

				google.maps.event.addDomListener(window, 'resize', function () {
					mapCenter.call(map);
				});

				google.maps.event.addListenerOnce(map, 'idle', function(){
					if (data.currentDepartment) {
						departmentMarkers[data.currentDepartment].setIcon(activePin);
						departmentPopups[data.currentDepartment].open(map, departmentMarkers[data.currentDepartment]);
						openedPopup = data.currentDepartment;
						initPopups($('.map-popup:visible'));
					}
				});

				mapCenter.call(map);
			}
		};

		/** Map redraw */
		window.mapRedraw = function () {
			mapCont.height(body.height() - mapCont.offset().top + 10);
		};

		/** Map centering */
		window.mapCenter = function () {
			mapRedraw();
			var center = this.getCenter();
			google.maps.event.trigger(this, 'resize');
			this.setCenter(center);
		};

		/** Map script */
		$.getScript('https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&language=ru-RU&callback=mapInit&key=AIzaSyA0HoTAdhItKayUeV3yP_SFVzHKCrE1d9E');
		$(this).show();
	});

	if ($('.scroll-helper').is(':visible')) {

		$('.scroll-helper').on('click', function() {
			event.preventDefault();
			var offset = $('figure.map').offset().top;
			if ( $('.schedule-list .item:eq(1)').length > 0)
				offset = $('.schedule-list .item:eq(1)').offset().top - 10;
			$('html, body').animate({scrollTop: offset});
		});

		$(window).on('scroll', function() {
			$('.scroll-helper').fadeOut();
		});
	}

	/** Location */
	$('.location .load-details').on('click', function(e) {
		e.preventDefault();
		$(this).closest('li').find('.details').fadeIn();
		$(this).hide();
	});

	/** Team */
	$('.team .load-details').on('click', function(e) {
		e.preventDefault();
		$(this).closest('.feature').find('.details').fadeIn();
		$(this).hide();
	});

	/** Location */
	$(document).on('click', '.news .load-details', function(e) {
		e.preventDefault();
		$(this).closest('.item').find('.details').fadeIn();
		$(this).hide();
	});

	var offset = 3;
    $('.news:not(.news-blog) .loadmore').on('click', function(e) {
        e.preventDefault();

        var button = $(this);
        if (button.is("[disabled]"))
            return;

        button
            .css('opacity', .5)
            .attr('disabled', 'disabled');

        $.get('/wordpress/wp-admin/admin-ajax.php', { action: 'get_news', offset: offset }, function(response) {
            response = JSON.parse(response);

            $(response.news)
                .appendTo('.news .list')
                .hide()
                .fadeIn();

            if (!response.more) {
                button.hide();
            }

            button
                .css('opacity', 1)
                .removeAttr('disabled');

            offset += 3;
        });
    });

	var blogOffset = 18;
    $('.news-blog .loadmore').on('click', function(e) {
        e.preventDefault();

        var button = $(this);
        if (button.is("[disabled]"))
            return;

        button
            .css('opacity', .5)
            .attr('disabled', 'disabled');

        $.get('/wordpress/wp-admin/admin-ajax.php', { action: 'get_articles', offset: blogOffset }, function(response) {
            response = JSON.parse(response);

            $(response.records)
                .appendTo('.news .list')
                .hide()
                .fadeIn();

            if (!response.more) {
                button.hide();
            }

            button
                .css('opacity', 1)
                .removeAttr('disabled');

            blogOffset += 18;
        });
    });

    $(document).on('click', '.scrollTo', function(e) {
     	var href = $(this).attr('href'),
     		partsOfHref = href.split('#');
     	if (!partsOfHref[0] || partsOfHref[0] == window.location.href) {
     		e.preventDefault();
     		scrollToBlock('#' + partsOfHref[1]);
     	}
    });

    $(document).on('click', '.js-popup[href="#popup-enroll"]', function() {
        $('#popup-enroll input[name=department_id]').val($(this).data('department_id'));
        $.magnificPopup.open({items:{src:"#popup-enroll",type:"inline"}});
    });

    $(document).on('click', '.js-close', function () {
    	event.preventDefault();
    	$.magnificPopup.close();
	});

    setTimeout(function() {
    	if (window.location.hash)
    		scrollToBlock(window.location.hash);
    }, 1000);

    function scrollToBlock(blockId) {
    	var target = $(blockId);
    	if (target.length)
        	$('html, body').animate({scrollTop: target.offset().top - 50});
    }

    $(document).on('submit', '.wpcf7-form', function() {
    	$(this).find('.wpcf7-submit').attr('disabled', 'disabled');
    });

    $(document).on('keydown', '.wpcf7-form input', function() {
    	$(this).closest('.wpcf7-form').find('.wpcf7-submit').removeAttr('disabled');
    });

    $('.social-share-link').on('click', function() {
    	event.preventDefault();
    	window.open($(this).attr("href"),'displayWindow', 'width=700,height=400,left=200,top=100,location=no,directories=no,status=no,toolbar=no,menubar=no');
    });

    var VKAttachments;
    $('.publish-post-in-vk').on('click', function() {
    	event.preventDefault();
    	VK.init({apiId: 5692706});
	    VK.Auth.login(function(r1) {
	    	if (r1.session) {
	    		var userID = r1.session.mid;

		    	// Получение адреса сервера
		    	VK.Api.call('photos.getWallUploadServer', {}, function(r2) {
		    		// Загрузка изображения
		    		$.ajax({
		    			type: 'POST',
		    			url: data.ajaxUrl,
		    			async: false,
		    			data: {
		    				action: 'upload_image',
		    				post_id: data.pageSubmitedID,
		    				url: r2.response.upload_url,
		    				nonce: data.uploadPhotoNonce
		    			},
		    			dataType: 'json',
		    			success: function(r3) {
		    				// Сохранение изображения
		    				VK.Api.call('photos.saveWallPhoto', {
	    						user_id: userID,
	    						photo: r3.photo,
	    						server: r3.server,
	    						hash: r3.hash,
	    					}, function(r4) {
	    						VKAttachments = r4.response;
	    						$.magnificPopup.open({items:{src:"#popup-share-confirmation",type:"inline"}});
		    				}); // photos.saveWallPhoto
			    		}
		    		}); // image upload
		    	}); // photos.getWallUploadServer
		    }
	    }, 4); // login
    });

    $(document).on('click', '.publish-post-in-vk-confirmation', function() {
    	// Размещение записи на стене
		VK.Api.call('wall.post', {
			message: data.title,
			attachments: VKAttachments[0].id + ',' + data.url
		}, function(r5) {
			if (r5.response && r5.response.post_id) {
				// Отправка письма
				$.post( data.ajaxUrl, {
	    				action: 'send_lessons',
	    				post_id: data.pageSubmitedID,
	    				email: data.email,
	    				nonce: data.sendLessonsNonce
	    			}
	    		);
		        $.magnificPopup.open({items:{src:"#popup-shared",type:"inline"}});
		    }
		}); // wall.post
    });

    $('.publish-post-in-fb').on('click', function() {
    	event.preventDefault();
    	FB.ui({
            method: 'feed',
            name: data.title,
            link: data.url,
            picture: data.image,
            description: data.description
        }, function(response) {
        	if (response && response.post_id) {
        		// Отправка письма
        		$.post( data.ajaxUrl, {
        				action: 'send_lessons',
        				post_id: data.pageSubmitedID,
        				email: data.email,
        				nonce: data.sendLessonsNonce
        			}
        		);
		        $.magnificPopup.open({items:{src:"#popup-shared",type:"inline"}});
		    }
        });
    });

	initPopups();
	initForms();

	$('.jsOpenRegionSwitch').on('click', function(event) {
		event.preventDefault();
		var regPopup = $(this).parents('.region');
		var regPopupPos = regPopup.offset();
		$('.region__menu_confirm').removeClass('region__menu_opened');
		$('.region__menu_switch').toggleClass('region__menu_opened');
		if ( $('.region__menu_switch').is(':visible') ) {
			$('.region').addClass('region_popup');
			$("html, body").animate({
				scrollTop: regPopupPos.top
			}, 500, 'swing');
		} else {
			$('.region').removeClass('region_popup');
		}
	});

	$('.jsCloseRegionMenu').on('click', function() {
		event.preventDefault();
		$('.region').removeClass('region_popup');
		$(this).closest('.region__menu').removeClass('region__menu_opened');
	});

	$('.jsMapChangeView').on('click', function() {
		event.preventDefault();
		$('.map__switch-item_active').removeClass('map__switch-item_active');
		$(this).addClass('map__switch-item_active');
		$('.map__container').attr('data-view', $(this).data('view'));
	});

	$('.jsMapToggleView').on('click', function() {
		event.preventDefault();
		$('.map__switch-item').toggleClass('map__switch-item_active');
		$('.map__container').attr('data-view', $('.map__switch-item_active').data('view'));
	});

	$('.jsRegionConfirm').on('click', function() {
		event.preventDefault();

		$('.region').removeClass('region_popup');
		$(this).closest('.region__menu').removeClass('region__menu_opened');

		$.get($(this).attr('href'));
	});

	$('.jsRegionChange').on('click', function() {
		event.preventDefault();

		var self = this;
		$.get($(this).attr('href'), function() {
			if (typeof $(self).data('redirect') === 'undefined') {
				window.location.reload();
			} else {
				window.location.replace($(self).data('redirect'));
			}
		});
	});

	if ($('.section--video .section__img').is(':visible')) {

		$('.jsVideoPopup').each(function () {
			$(this).magnificPopup({
				type: (typeof $(this).data('type') === 'undefined')? 'inline':$(this).data('type'),
				callbacks: {
					open: function() {
						player.pauseVideo();
					},
					close: function() {
						player.playVideo();
					}
				}
			});
		});

		var tag = document.createElement('script');

		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		var player;
		function onYouTubeIframeAPIReady() {
			player = new YT.Player('yt-background-video', {
				height: '360',
				width: '640',
				videoId: 'VIyrVJDGTxI',
				playerVars: {
					showinfo: 0,
					controls: 0,
					rel : 0,
					fs : 0,
					loop : 1,
					modestbranding: 0,
				},
				events: {
					onReady: onPlayerReady,
					onStateChange: function(e){
						if (e.data === YT.PlayerState.ENDED) {
							player.playVideo();
						}
					}
				}
			});
		}

		window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

		function onPlayerReady(event) {
			event.target.mute();
			event.target.playVideo();
		}
	} else {
		$('.jsVideoPopup').each(function () {
			$(this).magnificPopup({
				type: (typeof $(this).data('type') === 'undefined')? 'inline':$(this).data('type')
			});
		});
	}

});


/**
 * Init popups
 */
window.initPopups = function (scope) {

	if (typeof scope === 'undefined') {
		scope = document;
	}

	jQuery('.js-popup').each(function () {
		var d;
		if (typeof jQuery(this).data('type') === 'undefined') {
			d = "inline";
		} else {
			d = jQuery(this).data('type');
		}
		jQuery(this).magnificPopup({
			type: d
		});
	});
}

/**
 * Init forms
 */
window.initForms = function (scope) {

	if (typeof scope === 'undefined') {
		scope = document;
	}

	/** Default form submit */
    jQuery('.form:not(.wpcf7-form)').off('submit').on('submit', function () {
    	jQuery(this).find('.form-proceed').fadeToggle();
		return false;
	});

	jQuery('.form-subscribe:not(.wpcf7-form)').off('submit').on('submit', function () {
		jQuery.get('/wordpress/wp-admin/admin-ajax.php?action=subscribe&' + jQuery(this).serialize());
    	jQuery.magnificPopup.open({items:{src:"#popup-subscribed",type:"inline"}});
		return false;
	});

	/** Datepicker */
    jQuery('.datetimepicker').datetimepicker({
		i18n: {
			ru: {
				months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
				dayOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
			}
		},
		lang: 'ru',
		format: 'd.m.Y / H:i',
		allowTimes: ['10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00'],
		minDate: '-1970/01/02'
	});

	/** Phone mask */
	jQuery('input[name=phone]').mask("+7 (999) 999-99-99");
};


/** On popup opened */
window.onOpen = function () {

	/** Init inner forms */
	initForms(this.wrap);

	/** Rebind close button */
    jQuery('.js-close', this.wrap).unbind('click').on('click', function (e) {
    	jQuery.magnificPopup.close();
		e.preventDefault();
	});
};

/** On popup closed */
window.onClose = function () {
	jQuery('.form', this.wrap).each(function () {
    	this.reset();
        jQuery('.form-line-error', this).removeClass('form-line-error');
        jQuery('.wpcf7-not-valid', this).removeClass('wpcf7-not-valid');
        jQuery('.form-error, .wpcf7-not-valid-tip', this).remove();
        jQuery('.form-proceed', this).hide();
	});
};


/**
 * Magnific Popup default settings
 */
jQuery.extend(true, jQuery.magnificPopup.defaults, {
	tClose: 'Закрыть (Esc)',
	tLoading: '',
	closeMarkup: '<span title="%title%" class="mfp-close"><span class="mfp-in"></span></span>',
	ajax: {tError: '<a href="%url%">Контент</a> не найден.'},
	settings: {cache: false},
	mainClass: 'mfp-zoom-in',
	midClick: true,
	removalDelay: 300,
	autoFocusLast: false,
	preload: false,
	callbacks: {
		open: onOpen,
		beforeClose: onClose
	}
});
